import React from 'react'
import styles from './button.module.css'

export function Button({ type, label, size, onClick }) {
  const getClassName = () => {
    if (type === 'outline') {
      if (size === 'small') {
        return styles.buttonOutlineSmall
      }

      return styles.buttonOutline
    }

    return styles.button
  }

  return (
    <button className={getClassName()} onClick={onClick}>
      {label}
    </button>
  )
}

export function ButtonPrimary({ type, label, size, onClick }) {
  const getClassName = () => {
    if (type === 'outline') {
      if (size === 'small') {
        return styles.buttonPrimaryOutlineSmall
      }

      return styles.buttonPrimaryOutline
    }

    return styles.buttonPrimary
  }

  return (
    <button className={getClassName()} onClick={onClick}>
      {label}
    </button>
  )
}

export function ButtonLink({ type, label, disabled = false, onClick }) {
  const getClassName = () => {
    if (type === 'primary') {
      return styles.buttonLinkPrimary
    }

    return styles.buttonLink
  }

  return (
    <button className={getClassName()} disabled={disabled} onClick={onClick}>
      {label}
    </button>
  )
}
